const translate = {
    shared: {
        cancel: "Cancel",
        send: "Send",
        image: "Image",
        file: "File",
        location: "Location",
    },
    chat: {
        askYourQuestion: "Ask your question",
        enterYourMessage: "Enter your message",
        you: "You",
        operator: "Operator",
        system: "System",
        resetChatQuestion: "Are you sure you want to clear the chat?",
    },
};

export default translate;
